import React from "react";
import ServicesHeader from "./ServicesHeader";
import MultilingualIllustration from "./MultilingualIllustration";

const OtherLanguageServices = () => {
  return (
    <section className="w-full bg-[#F4F9F6] pt-16 sm:pt-20 lg:pt-24 pb-8 sm:pb-12 lg:pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto flex flex-col items-center">
        {/* Header content: Eyebrow, Title, Description, and CTA */}
        <ServicesHeader />

        {/* Multilingual characters illustration */}
        <MultilingualIllustration />
      </div>
    </section>
  );
};

export default OtherLanguageServices;
